'use strict';

angular.module('cvsApp').controller('ConfigCtrl', ["$scope", "$state",  function($scope, $state) {
  $scope.continue = function(target) {
      $state.go("srx-payment-widget", {display:target});
  };

}]);
